import React from 'react';

import { useIntl } from 'react-intl-next';

import Image from '@atlaskit/image';

import { GlobalSideNavigationNoContent } from '../../../common/ui/no-content';

import SearchNoResultsDark from './assets/no-results-dark.svg';
import SearchNoResultsLight from './assets/no-results-light.svg';
import messages from './messages';

export function ObjectListFlyoutNoResultsState() {
	const { formatMessage } = useIntl();

	return (
		<GlobalSideNavigationNoContent
			testId="object-list-flyout--no-results-state"
			renderImage={() => (
				<Image src={SearchNoResultsLight} srcDark={SearchNoResultsDark} width={96} alt="" />
			)}
			heading={formatMessage(messages.noResultsStateHeader)}
			description={formatMessage(messages.noResultsStateDescription)}
		/>
	);
}
